import styled from 'styled-components';

const IntenseLabel = styled.div`
  color: ${({ theme }) => theme.atlas.text.secondary};
  ${({ theme }) => theme.fonts.bold.small};
`;

export default IntenseLabel;
